import { ChangeDetectorRef, Component } from '@angular/core';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    selector: 'installation-preparationneeded',
    templateUrl: './preparation-needed.component.html',
    standalone: false
})
export class InstallationPreparationNeededPluginComponent {
  public preparation: any;
  public config: any;
  public editRoute = ['installation', 'preparationneeded', 'edit'];

  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.preparation = this.config.Preparation;
  }
}
PluginComponent.plugins['installationpreparationneeded'] = InstallationPreparationNeededPluginComponent;
